import { ref } from 'vue';
import { defineStore } from 'pinia';

const useDialogsStore = defineStore('dialogs', () => {
  // State
  const globalDialog = ref(null);
  const showDepotSelectionDialog = ref(false);
  const showTenantSelectionDialog = ref(false);

  // Actions
  const toggleDepotSelectionDialog = (isOpened) =>
    (showDepotSelectionDialog.value = isOpened);
  const toggleTenantSelectionDialog = (isOpened) =>
    (showTenantSelectionDialog.value = isOpened);
  const toggleGlobalDialog = (dialogData) => (globalDialog.value = dialogData);

  return {
    globalDialog,
    showDepotSelectionDialog,
    showTenantSelectionDialog,
    toggleDepotSelectionDialog,
    toggleTenantSelectionDialog,
    toggleGlobalDialog
  };
});

export default useDialogsStore;
